import Client from "./Clients/AxiosClient";
const resource = "/api";

export default {
  datesForPrinting() {
    return Client.get(`${resource}/Dates`, {
      withCredentials: true,
      responseType: "json"
    });
  },
  getUntakenShotAppointments(dateAndLocation) {
    return Client.get(`${resource}/Appointments/` + dateAndLocation, {
      withCredentials: true,
      responseType: "json",
      headers: { "Content-Type": "application/json" }
    });
  },
  reviewShotAppointments(userId) {
    return Client.get(`${resource}/ReviewAppointments/` + userId, {
      withCredentials: true,
      responseType: "json",
      headers: { "Content-Type": "application/json" }
    });
  },
  createShotAppointment(makeAppointmentParameters) {
    return Client.post(
      `${resource}/MakeAppointment`,
      makeAppointmentParameters,
      {
        withCredentials: true,
        responseType: "json",
        headers: { "Content-Type": "application/json" }
      }
    );
  },
  cancelShotAppointment(userId) {
    return Client.get(`${resource}/CancelAppointments/` + userId, {
      withCredentials: true,
      responseType: "json",
      headers: { "Content-Type": "application/json" }
    });
  },
  deleteShotAppointment(userId) {
    return Client.delete(`${resource}/CancelAppointments/` + userId, {
      withCredentials: true,
      responseType: "json",
      headers: { "Content-Type": "application/json" }
    });
  }  
};
